import React, { Component } from "react";
import _ from "lodash";
// Externals
import PropTypes from "prop-types";
import classNames from "classnames";

// Material helpers
import { withStyles } from "@material-ui/core";

// Material components
import { Grid, Typography, Paper, CardActions } from "@material-ui/core";
// Shared components
import { IntentCard } from "..";

// Component styles
import styles from "./styles";

class IntentsList extends Component {
  renderIntents() {
    const { intents } = this.props;

    const intentsFiltered = _.filter(intents, intent => {
      return intent.visible;
    });

    if (intentsFiltered.length === 0) {
      return <Typography variant="h6">There are no tasks available</Typography>;
    }

    return (
      <Grid container spacing={8}>
        {intentsFiltered.map(intent => (
          <Grid item key={intent.ID} lg={2} md={4} xs={12}>
            <IntentCard intent={intent} onIntentClick={this.props.onIntentClick} />
          </Grid>
        ))}
      </Grid>
    );
  }

  render() {
    const { classes, className } = this.props;
    const rootClassName = classNames(classes.root, className);

    return (
      <div className={rootClassName}>
        <Paper className={classes.row}>
          <CardActions className={classes.listHeader}>
            <Typography variant="h5">
              <span>{this.props.name}</span>
            </Typography>
          </CardActions>
          <Grid item md={12} xs={12} className={classes.rowContent}>
            {this.renderIntents()}
          </Grid>
        </Paper>
      </div>
    );
  }
}

IntentsList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  intents: PropTypes.array.isRequired,
  onIntentClick: PropTypes.func.isRequired
};

export default withStyles(styles)(IntentsList);
